<template>
  <v-card>
    <v-card-title class="headline">
      <slot name="header"></slot>
    </v-card-title>
    <v-spacer />
    <v-card-text>
      <slot></slot>
    </v-card-text>
    <v-spacer />
    <v-card-actions>
      <SubmitGroup @close="onCloseDialogHandler" @submit="onSubmitHandler" />
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  components: {
    SubmitGroup: () => import('@/components/SubmitGroup')
  },
  methods: {
    onCloseDialogHandler: function() {
      this.$emit('close', false)
    },
    onSubmitHandler: function() {
      this.$emit('submit')
    }
  }
}
</script>
